import { Box, Typography, useTheme } from "@material-ui/core";

import { useTranslation } from "react-i18next";
import formatCurrency from "../utils/currency-format";
import renderCurrency from "../utils/currency";
export interface AdjustmentTooltipProps {
	wasAdjustedBefore: boolean;
	adjustedAmount?: number | null;
	adjustedRate?: number | null;
	originalAmount?: number | null;
	currency?: string;
	lastAdjustedAt?: string;
	adjustedBy?: string;
	adjustmentComment?: string;
	canUserViewFinancials: boolean;
}

const getAdjustment = (original: number | undefined, adjusted: number | undefined, currency: string | undefined) => {
	if (!original || !adjusted) {
		return "";
	}

	const adjustment = original - adjusted;
	return `${adjustment < 0 ? "+" : "-"} ${renderCurrency(Math.abs(adjustment), currency, 2, 2)}`;
};

const AdjustmentTooltip = (props: AdjustmentTooltipProps) => {
	const { t } = useTranslation();
	const { spacing } = useTheme();
	const adjustment = getAdjustment(props.originalAmount!, props.adjustedAmount!, props.currency);

	if (!props?.wasAdjustedBefore || !props.canUserViewFinancials) {
		return <>{""}</>;
	}

	return (
		<div style={{}}>
			<Box display="flex" justifyContent="space-between" m={1}>
				<Typography style={{ marginRight: spacing(4) }}>{t("transaction-adjusted-amount")}: </Typography>
				<Typography>{renderCurrency(props.adjustedAmount, props.currency, 2, 2)}</Typography>
			</Box>

			<hr />
			<Box display="flex" justifyContent="space-between" m={1}>
				<Typography style={{ marginRight: spacing(4) }}>{t("transaction-original-amount")}</Typography>
				<Typography>{renderCurrency(props.originalAmount, props.currency, 2, 2)}</Typography>
			</Box>
			{props.originalAmount && props.adjustedAmount && (
				<Box display="flex" justifyContent="space-between" m={1}>
					<Typography style={{ marginRight: spacing(4) }}>{t("transaction-adjustment")}</Typography>
					<Typography>{adjustment}</Typography>
				</Box>
			)}
			<Box display="flex" justifyContent="space-between" m={1}>
				<Typography style={{ marginRight: spacing(4) }}>{t("transaction-adjusted-rate")}</Typography>
				<Typography>
					{formatCurrency(props.adjustedRate, 2, 2)}
					{" %"}
				</Typography>
			</Box>
			<Box display="flex" justifyContent="space-between" m={1}>
				<Typography style={{ marginRight: spacing(4) }}>{t("transaction-last-adjusted-date")}</Typography>
				<Typography>{props.lastAdjustedAt}</Typography>
			</Box>
			{props.adjustedBy && (
				<Box display="flex" justifyContent="space-between" m={1}>
					<Typography style={{ marginRight: spacing(4) }}>{t("transaction-last-adjusted-by")}</Typography>
					<Typography>{props.adjustedBy}</Typography>
				</Box>
			)}
			{props.adjustmentComment && (
				<Box m={1}>
					<Typography display="block">
						<i>"{props.adjustmentComment}"</i>
					</Typography>
				</Box>
			)}
		</div>
	);
};

export default AdjustmentTooltip;
